import React from 'react';
import ReactPaginate from 'react-paginate';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
export const Pagination = ({ pagecount, onpress }) => {
  const handlePageClick = (data) => {
    onpress(data.selected + 1);
  };
  return (
    <ReactPaginate
      breakLabel="..."
      onPageChange={handlePageClick}
      pageCount={pagecount}
      nextLabel={<KeyboardDoubleArrowRightIcon />}
      previousLabel={<KeyboardDoubleArrowLeftIcon />}
      containerClassName="pagination-container"
      pageClassName="pagination-item"
      pageLinkClassName="pagination-link"
      previousClassName="pagination-item"
      nextClassName="pagination-item"
      previousLinkClassName="pagination-link"
      nextLinkClassName="pagination-link"
      breakClassName="pagination-item"
      breakLinkClassName="pagination-link"
      activeClassName="pagination-active"
      activeLinkClassName="pagination-active-link"
    />
  );
};
